// src/constants/metricsDefinitions.js
const metricDefinitions = {
  currentRatio:
    "Q: Can the company cover its short-term obligations?<br /><br />Measures a company’s ability to pay short-term liabilities with short-term assets. A ratio above 1.0 typically indicates good liquidity.<br /><br />Higher is generally better.",

  quickRatio:
    "Q: Can the company quickly pay its short-term debts without selling inventory?<br /><br />A more stringent liquidity measure than the current ratio, excluding inventory. Shows the ability to meet short-term obligations using only liquid assets.<br /><br />Higher is better.",

  grossProfitMargin:
    "Q: How efficiently does the company produce its goods or services?<br /><br />Indicates how well a company controls its production costs relative to revenue. Higher margins suggest better cost control or pricing power.<br /><br />Higher is better.",

  operatingProfitMargin:
    "Q: How profitable is the company from its core operations?<br /><br />Reflects core operating profitability before interest and taxes. Useful for assessing efficiency of core operations.<br /><br />Higher is better.",

  netProfitMargin:
    "Q: How much actual profit does the company keep from its revenue?<br /><br />Shows the percentage of revenue that turns into profit after all expenses. A key measure of overall profitability.<br /><br />Higher is better.",

  returnOnAssets:
    "Q: How effectively is the company using its assets to generate profit?<br /><br />Indicates how efficiently a company uses its assets to generate net income. Higher values imply better asset utilization.<br /><br />Higher is better.",

  returnOnEquity:
    "Q: How well is the company rewarding its shareholders?<br /><br />Measures how effectively a company generates profit from shareholders’ equity. A key profitability metric for investors.<br /><br />Higher is better.",

  debtEquityRatio:
    "Q: How much financial risk is the company taking on through debt?<br /><br />Shows the proportion of debt to shareholder equity. High values may indicate higher financial risk due to leverage.<br /><br />Lower is better.",

  freeCashFlowPerShare:
    "Q: How much free cash flow is available per share?<br /><br />Represents the company’s free cash flow divided by its number of outstanding shares. Useful for comparing cash generation on a per-share basis.<br /><br />Higher is better.",

  freeCashFlowOperatingCashFlowRatio:
    "Q: How much of the operating cash flow turns into free cash flow?<br /><br />Shows the percentage of operating cash flow that remains after capital expenditures. Higher ratios indicate better cash efficiency.<br /><br />Higher is better.",

  priceToFreeCashFlowsRatio:
    "Q: How expensive is the stock based on its free cash flow?<br /><br />Valuation metric comparing market capitalization to free cash flow. Lower values may indicate undervaluation.<br /><br />Lower is better.",

  priceEarningsRatio:
    "Q: How expensive is the stock relative to its earnings?<br /><br />Valuation metric showing how much investors are willing to pay per dollar of earnings. High values may signal growth expectations or overvaluation.<br /><br />Lower is generally better, unless growth is expected.",

  priceToSalesRatio:
    "Q: Is the stock overvalued or undervalued based on revenue?<br /><br />Valuation ratio comparing a company’s stock price to its revenues. Useful when earnings are negative or volatile.<br /><br />Lower is better."
};

export default metricDefinitions;

